import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

import { WarehouseAxios } from "api/WarehouseAxios";
import { api } from "helpers/api_url";
import moment from "moment";
// import { Axios } from "api/WarehouseAxios";

export const fetchInStock = createAsyncThunk(
  "InStock/fetchInStock",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id: string
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await Axios.get(
      `${api?.warehouse?.warehouse_overview?.in_stock?.listing}?warehouse_id=${warehouse_id}&${params.toString()}`
    );

    
    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportInStockCSV = createAsyncThunk(
  "InStock/exportInStockCSV",
  async (
    {
      page,
      pageSize,
      sort,
      order,
      search,
      filters,
      columnFilters,
      warehouse_id,
    }: {
      page: number;
      pageSize: number;
      search?: string;
      sort?: string;
      order?: "asc" | "desc" | "";
      filters?: any[];
      columnFilters?: any[];
      warehouse_id?: string;
    },
    thunkAPI: any
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      params.append("export", "csv");

      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (warehouse_id) {
        params.append("warehouse_id", warehouse_id);
      }

      // Handle filterValue filters
      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                  if (
                    (filterValue.from_date || filterValue.to_date) &&
                    (filterField === "created_at" || filterField === "updated_at")
                  ) {
                    if (filterField === "created_at") {
                      filterField = "created";
                    } else {
                      filterField = "updated";
                    }
                    params.append("filter_by", filterField);
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      // Handle columnFilters
      if (columnFilters && columnFilters.length > 0) {
        columnFilters.forEach((f: any) => {
          if (f.id && f.value !== undefined && f.value !== null && f.value !== "") {
            params.append(f.id, f.value);
          }
        });
      }

      const response: any = await Axios.get(
        `${api?.warehouse?.warehouse_overview?.in_stock?.listing}?${params.toString()}`,
        { responseType: "blob" }
      );

      // Check if response is JSON error instead of CSV
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        return thunkAPI.rejectWithValue(errorData?.message || "Export failed");
      }

      // Extract filename
      const disposition = response.headers["content-disposition"];
     let filename = `in_stock_${moment().format("YYYY-MM-DD")}.csv`;
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) filename = match[1];
      }

      // Trigger download
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = urlBlob;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlBlob);

      return { success: true };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Export failed"
      );
    }
  }
);



// view details api called below


// export const exportInStockViewDetailsCSV = async () => {
//   const response = await WarehouseAxios.get(
//     "/warehouse/dailyLogs/?export=csv",
//     {
//       responseType: "blob",
//     }
//   );

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "purchaseRequest.csv",
//   };
// };
